export default "__VITE_ASSET__eCaRriBe__"